var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwdFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h67.5v45H0V0Z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h33.75v22.5H0V0Z",
    fill: "#000095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.438 11.897-.235.9.881.244-.168-.666-.479-.478Zm4.396.478-.168.666.88-.244-.233-.9-.479.478Zm-3.918-2.25-.479.478.179.647.3-1.125Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.616 11.25-.178.647.478.478-.3-1.125Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.437 10.603-.646.647.646.647.179-.647-.179-.647Zm1.313 2.606.478.478.647-.178-1.125-.3Zm1.772.478.9.235.244-.882-.666.17-.478.477Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 13.21.666-.17.168-.665-.834.834Zm-2.915-.17.243.882.9-.235-.478-.478-.665-.168Zm1.79.47.647.178.478-.479-1.125.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.228 13.688.647.646.647-.646-.647-.179-.647.179Zm-1.144-4.229-.88.244.233.9.479-.478.168-.666Zm-.168 2.916.168.666.666.168-.834-.834Zm4.218-1.125.178-.647-.478-.478.3 1.125ZM15.75 9.29l-.666.17-.168.665.834-.834Zm3.084.835-.168-.666L18 9.291l.834.834Zm.478 1.772.647-.647-.647-.647-.178.647.178.647Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.834 10.125 18 9.291l-1.125-.3-1.125.3-.834.834-.3 1.125.3 1.125.834.835 1.125.3 1.125-.3.834-.835.3-1.125-.3-1.125ZM18.834 12.375l.479-.478-.178-.647-.3 1.125Zm.479-1.772.234-.9-.881-.244.168.666.479.478Zm-.647-1.144-.244-.88-.9.233.478.479.666.168Zm-2.438-.646-.9-.235-.243.881.665-.168.478-.479Zm.647.178-.647-.178-.478.478 1.125-.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.522 8.812-.647-.646-.647.646.647.179.647-.179ZM18 9.29l-.478-.477-.647.178 1.125.3Zm-1.772 4.398-.9.234.422 1.556 1.125-1.144-.647-.646Zm-.478 1.79 1.125 4.21L18 15.477l-1.125-1.144-1.125 1.144Zm-.666-2.437-.881-.244-.412 1.537 1.537-.412-.244-.881Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.79 14.334-1.124 4.229 3.084-3.085-.422-1.556-1.537.412Zm-1.124-1.959-3.104 3.103 4.229-1.144.412-1.537-1.537-.422Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.437 11.897-.646-.647-1.126 1.125 1.538.422.234-.9Zm0-1.294-.234-.9-1.537.422 1.124 1.125.647-.647Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.666 10.125 8.437 11.25l4.229 1.125 1.125-1.125-1.125-1.125Zm8.437 2.25-1.556.422.412 1.537 4.229 1.144-3.085-3.103Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.666 13.04-.244.882 1.537.412-.412-1.537-.881.244Zm-1.144.648-.647.646L18 15.478l.422-1.556-.9-.235Zm1.79-1.791.235.9 1.556-.422-1.144-1.125-.646.647ZM18 15.478l3.103 3.084-1.144-4.228-1.537-.412L18 15.478Zm.666-6.019.88.244.413-1.537-1.537.412.244.881Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.103 10.125 3.084-3.084-4.228 1.125-.412 1.537 1.556.422Zm-1.144-1.96 1.144-4.227L18 7.04l.422 1.537 1.537-.412Zm1.144 4.21 4.21-1.125-4.21-1.125-1.144 1.125 1.144 1.125ZM19.312 10.603l.647.647 1.144-1.125-1.556-.422-.235.9ZM15.75 7.041l-3.085-3.104 1.126 4.229 1.537.412.422-1.537Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.084 9.46.244-.882-1.537-.412.412 1.537.881-.244Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.79 8.166 9.564 7.04l3.103 3.084 1.537-.422-.412-1.537Zm3.732.646.9-.234L18 7.041l-1.125 1.125.647.646ZM18 7.04l-1.125-4.228-1.125 4.229 1.125 1.125L18 7.04Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.228 8.812.647-.646L15.75 7.04l-.422 1.537.9.234Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875 16.04a4.79 4.79 0 1 0 0-9.58 4.79 4.79 0 0 0 0 9.58Z",
    fill: "#000095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875 15.478a4.228 4.228 0 1 0 0-8.456 4.228 4.228 0 0 0 0 8.456Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwdFlag);
export default __webpack_public_path__ + "static/media/twd-flag.d23c42e26548d1a484e5d5f93162f095.svg";
export { ForwardRef as ReactComponent };